import React, { useState } from "react";
import "../css/media-query.css";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
    robot: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Gmail validation
    if (!form.email.endsWith("@gmail.com")) {
      alert("Please enter a valid Gmail address ❌");
      return;
    }

    // ✅ Robot check
    if (!form.robot) {
      alert("Please confirm you are not a robot 🤖");
      return;
    }

    alert("Message submitted successfully ✅");
    console.log(form);
  };

  return (
    <>

      <div className="contact-container">
        <h2>Contact Us</h2>

        <form onSubmit={handleSubmit} className="contact-form">

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Gmail"
            value={form.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={form.message}
            onChange={handleChange}
            required
          />

          <label className="robot-check">
            <input
              type="checkbox"
              name="robot"
              checked={form.robot}
              onChange={handleChange}
            />
            I am not a robot
          </label>

          <button type="submit">Send Message</button>

        </form>
      </div>
    </>
  );
}

export default Contact;
